import type { FaireProductEntity } from "../../entity_types/product";

export const p_f9s43q2k4r: FaireProductEntity = {
  token: "p_f9s43q2k4r",
  type: "product",
  name: "You're Shrimply The Best Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/0a2942056783f1728ca766f99d371371a07981e409fd7e6b271f4ec2f0a00828.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/146ce3d3af079b24a5a146f39515403ab93090d98878fbb5834357f4d3736c4a.jpeg",
    "https://cdn.faire.com/fastly/f0c26afbb68b4d432f2e921c072c51e61c717b9c74b86e3345c38a6ea51008c9.jpeg",
    "https://cdn.faire.com/fastly/3b76f645e73e17696a26feba859d0be8508550dbcaf3614877528470508dd60e.jpeg",
    "https://cdn.faire.com/fastly/2275cac58394ac8d95f1dbf2cd3c1e101945e3e882706000b27e352cb599b474.jpeg",
    "https://cdn.faire.com/fastly/f88c7a78c273af9fbf801990c51021b9ee0697591cb530569cd825087febfc73.jpeg",
    "https://cdn.faire.com/fastly/25faf10b0c71188ef19b05fff55f777c635c70498fad99ecc44e576223946360.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our Valentine's Day Collection featuring an all-over design displaying a pattern of shrimp and love hearts with a funny love-themed pun that reads \"You're Shrimply The Best!\" Shrimp inspired pattern is replicated from playful hand illustrated artwork. Double-sided towel displays a coordinating stripe pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Our Shrimply The Best kitchen towel is conveniently machine washable for easy cleaning. Microfiber towel is packaged on a cardboard hanger with hole to easily display on store rack. A fun love-themed gift perfect for both friends and partners on Valentine's Day or in everyday moments.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:13.113Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
